import { FC } from "react";
import SyncIcon from "../../../assets/sync-icon.svg";
import Heading from "../../common/Heading";

interface MainHeaderProps {
	children?: React.ReactNode;
	customClass?: string;
	headerName: string;
}

const MainHeaderUpdated: FC<MainHeaderProps> = ({
	children,
	customClass,
	headerName,
}: MainHeaderProps) => {
	return (
		<div
			className={`flex flex-col h-auto justify-start  bg-white px-[1.5%] pt-[4px] border-b-[0.5px] border-lightGrey shadow-md ${customClass ? customClass : ""
				}`}
		>
			<Heading name={headerName} />

			{children && children}
		</div>
	);
};

export default MainHeaderUpdated;
